import {
    COLLECT_MOTOR_INSURANCE_QUOTE_FORM_DATA,
    COLLECT_SHARE_QUOTE_FORM_DATA,
    TRIGGER_GET_ALL_CAR_MAKES,
    TRIGGER_GET_ALL_CAR_MODELS,
    TRIGGER_GET_UG_VALUERS,
    SUBMIT_UG_QUOTE_FORM_DATA,
    TRIGGER_GET_UG_CAR_MAKES,
    TRIGGER_GET_UG_CAR_MODELS,
    TRIGGER_SEND_CUSTOMER_CARE_MAIL,
} from '../../../actions/ugMotorInsurance/quote';
import { TRIGGER_FETCH_UG_AGENTS } from '../../../actions/ugMotorInsurance/motorAgentModal';
import { getAgentsService } from './agents';
import {
    TRIGGER_PAYMENTS_STK_PUSH,
    CHECK_PAYMENTS_STATUS,
    SUBMIT_UG_PAYMENT_FORM_DATA,
    TRIGGER_CONFIRM_ORDER,
    SUBMIT_UG_BANK_PAYMENT_FORM_DATA,
} from '../../../actions/ugMotorInsurance/payments';
import { paymentsStkService, paymentsStkStatusService } from './payments';
import { premiumCalculationService } from './premiumCalculation';
import { COLLECT_PAYLOAD_DATA } from '../../../actions/ugMotorInsurance/payloadCollection';
import { payloadSubmitService } from './payloadCollection';
import { shareQuoteService } from './shareQuote';
import { COLLECT_LOGIN_DETAILS } from '../../../actions/ugMotorInsurance/auth';
import { loginService } from './login';
import { getCarMakesService } from './carMake';
import { getCarModelsService } from './carModels';
import { getValuersService } from './valuers';
import { amlWhitelistCheckService } from './amlWhitelist';
import {
    TRIGGER_AML_WHITELIST_CHECK,
    SUBMIT_UG_PERSONAL_DETAILS_FORM_DATA,
    TRIGGER_NIRA_CHECK,
} from '../../../actions/ugMotorInsurance/personalDetails';
import { getUgCarMakesService } from './carMakeUg';
import { getUgCarModelsService } from './carModelsUg';
//tagging services
import { submitQuoteDetailsService } from './submitQuote';
import { submitPersonalDetailsService } from './submitPersonalDetails';
import { UPLOAD_SINGLE_UG_DOCUMENT, UPLOAD_UG_DOCUMENT_DATA } from '../../../actions/ugMotorInsurance/Documents';
import { uploadDocumentsService, uploadSingleDocumentService } from './uploadDocuments';
import { SUBMIT_UG_CAR_DETAILS_FORM_DATA } from '../../../actions/ugMotorInsurance/carDetails';
import { submitVehicleDetailsService } from './submitVehicleDetails';
import { submitDeclarationsService } from './submitDeclarations';
import { SUBMIT_UG_NEXT_OF_KIN_FORM_DATA } from '../../../actions/ugMotorInsurance/nextOfKin';
import { nextOfKinSubmitService } from './submitNextOfKin';
import { SUBMIT_UG_DECLARATIONS_FORM_DATA } from '../../../actions/ugMotorInsurance/declarations';
import { submitPaymentDetailsService } from './submitPaymentData';
import { orderConfirmationService } from './orderConfirmation';
import { submitBankPaymentDetailsService } from './submitBankPaymentData';
import { niraCheckService } from './niraVerify';
import { sendCustomerMailService } from './sendCustomerCareMail';

const gatsbyStack = process.env.GATSBY_COUNTRY_SELECTOR;

export const ugMotorInsuranceCover = (store, next, action) => {
    if (action.type.startsWith(TRIGGER_AML_WHITELIST_CHECK)) {
        return amlWhitelistCheckService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_NIRA_CHECK)) {
        return niraCheckService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_PAYMENTS_STK_PUSH)) {
        return paymentsStkService(store, next, action);
    }
    if (action.type.startsWith(CHECK_PAYMENTS_STATUS) && gatsbyStack === 'ug') {
        return paymentsStkStatusService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_MOTOR_INSURANCE_QUOTE_FORM_DATA)) {
        return premiumCalculationService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_PAYLOAD_DATA)) {
        return payloadSubmitService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_CONFIRM_ORDER) && gatsbyStack === 'ug') {
        return orderConfirmationService(store, next, action);
    }

    if (action.type.startsWith(COLLECT_SHARE_QUOTE_FORM_DATA) && gatsbyStack === 'ug') {
        return shareQuoteService(store, next, action);
    }
    if (action.type.startsWith(COLLECT_LOGIN_DETAILS)) {
        return loginService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_ALL_CAR_MAKES)) {
        return getCarMakesService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_ALL_CAR_MODELS)) {
        return getCarModelsService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_UG_CAR_MAKES)) {
        return getUgCarMakesService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_UG_CAR_MODELS)) {
        return getUgCarModelsService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_GET_UG_VALUERS)) {
        return getValuersService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_FETCH_UG_AGENTS)) {
        return getAgentsService(store, next, action);
    }

    //motor ug tagging endpoints
    if (action.type.startsWith(SUBMIT_UG_QUOTE_FORM_DATA)) {
        return submitQuoteDetailsService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_UG_PERSONAL_DETAILS_FORM_DATA)) {
        return submitPersonalDetailsService(store, next, action);
    }

    if (action.type.startsWith(UPLOAD_SINGLE_UG_DOCUMENT)) {
        return uploadSingleDocumentService(store, next, action);
    }

    if (action.type.startsWith(UPLOAD_UG_DOCUMENT_DATA)) {
        return uploadDocumentsService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_UG_CAR_DETAILS_FORM_DATA)) {
        return submitVehicleDetailsService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_UG_DECLARATIONS_FORM_DATA)) {
        return submitDeclarationsService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_UG_NEXT_OF_KIN_FORM_DATA)) {
        return nextOfKinSubmitService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_UG_PAYMENT_FORM_DATA) && gatsbyStack === 'ug') {
        return submitPaymentDetailsService(store, next, action);
    }

    if (action.type.startsWith(SUBMIT_UG_BANK_PAYMENT_FORM_DATA) && gatsbyStack === 'ug') {
        return submitBankPaymentDetailsService(store, next, action);
    }

    if (action.type.startsWith(TRIGGER_SEND_CUSTOMER_CARE_MAIL)) {
        return sendCustomerMailService(store, next, action);
    }

    return null;
};
